import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { popUpMenuChange,
        selectedCardsGroupsChange,
        popUpMessageChange,
        editCards, 
        deleteCards, 
        editFeaturesGroup, 
        editFigures } from '../../../actions/index';

import Icon from '@mdi/react';
import { mdiSetSplit } from '@mdi/js';

import { postData } from '../../../functions/postData.js';
import { _ } from '../../../functions/translator'
import { reloadCardsGroupsFeatures } from '../../../functions/map/reloadCardsGroups';
import { showMessage } from '../../../functions/popUpMessage.js';

class SeparateButton extends React.Component{

    getSeparableTotal = () => {
        let text = ''
        if (this.props.separableCardsGroups.length > 0) {
            text += '(' + this.props.separableCardsGroups.length + ' '
            text += this.props.separableCardsGroups.length > 1 ? _('disponibles') + ')' : _('disponible') + ')'
        }
        return text
    }

    separateCardsGroups = async () => {
        this.props.popUpMenuChange({
            show: false,
            close: false,
            opacity: this.props.popUpMenu.opacity ? 0 : 1,
            cyclesButton: false
        })
        this.props.selectedCardsGroupsChange([])
        const message = _("Desagrupando Protocolos") + '...';
        showMessage(this.props, message, { loading: true });
        let urlPost = {
            project_id: window.project_id,
            cards_group_ids: this.props.separableCardsGroups
        }
        let response = await postData('/web-api/separate-cards-groups/full', urlPost)
        this.handleResponse(response)
    }

    handleResponse = (response) => {
        if(response) {
            this.props.deleteCards(this.props.separableCardsGroups)
            let cardsGroupIdsToReload = response.new_cards_group_ids.concat(this.props.separableCardsGroups);
            reloadCardsGroupsFeatures(this.props, cardsGroupIdsToReload)
            showMessage(this.props, '¡' + _('Se han desagrupado los protocolos correctamente') + '!');
        } else {
            showMessage(this.props, _('No se pudieron desagrupar los protocolos') + '.');
        }
    }

    render(){   
        
        let separableTotal = this.getSeparableTotal()
        return (
            <div>
                <div 
                    className={`popup-menu-button card-color 
                        ${this.props.separableCardsGroups.length === 0 && 'visible-disabled'}`
                    } 
                    ref={ref => this.button = ref } 
                    onClick={this.separateCardsGroups}>
                    <div className='d-inline-flex'>
                        <Icon path={ mdiSetSplit } size='30px' color='white' style={{margin: 10}}/>
                        <p>{ _('Desagrupar') }<span>{ separableTotal }</span></p>
                    </div>
                </div>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        projectData : state.projectData,
        popUpMenu : state.popUpMenu,
        selectedCardsGroups : state.selectedCardsGroups
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({
        popUpMenuChange : popUpMenuChange,
        selectedCardsGroupsChange : selectedCardsGroupsChange,
        popUpMessageChange : popUpMessageChange,
        editFeaturesGroup : editFeaturesGroup,
        deleteCards : deleteCards,
        editCards : editCards,
        editFigures : editFigures
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(SeparateButton)